import type { DrawerTabsProps } from './types';

import { Tabs, TabsList, TabsTrigger, TabsContent } from '../Tabs';

const DrawerTabs = ({ tabs }: DrawerTabsProps) => {
  const tabNames = Object.keys(tabs).map((key) => ({
    key,
    title: key,
    content: tabs[key]
  }));

  const removeUnderscore = (str: string) => str.replace(/_/g, ' ');

  return (
    <Tabs defaultValue={tabNames[0]?.key} className={'w-auto mx-6 my-3'}>
      <TabsList>
        {tabNames.map((tab) => (
          <TabsTrigger key={tab.key} value={tab.key}>
            {removeUnderscore(tab.title)}
          </TabsTrigger>
        ))}
      </TabsList>
      {tabNames.map((tab) => (
        <TabsContent key={tab.key} value={tab.key}>
          {tab.content}
        </TabsContent>
      ))}
    </Tabs>
  );
};

export { DrawerTabs };
